<app-navbar (collapsed)="navbarCollapsed = $event"></app-navbar>
<div class="main-wrapper" [class]="{'main-wrapper--extended': navbarCollapsed}">
  <mat-progress-bar mode="indeterminate" *ngIf="!viewDashboard"></mat-progress-bar>
  <router-outlet *ngIf="viewDashboard"></router-outlet>
</div>